// extracted by mini-css-extract-plugin
export default {"AiLoadingScreen__Container":"AiLoadingScreen_AiLoadingScreen__Container__5xdoM","AiLoadingScreen__Message":"AiLoadingScreen_AiLoadingScreen__Message__5fcbX"};